import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output
} from '@angular/core';

@Directive({
  selector: '[appNumericInput]'
})
export class NumericInputDirective {
  @Output() valueChange = new EventEmitter<string>();
  @Output() errorStatus = new EventEmitter<boolean>();

  private showError = false;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const val = input.value;
    const isValid = /^-?\d*$/.test(val); // Allow optional leading -

    if (isValid) {
      this.valueChange.emit(val);
      this.showError = false;
    } else {
      this.showError = true;
      // Remove all characters except digits and leading minus
      let cleaned = val.replace(/[^\d-]/g, '');

      // Ensure only one leading minus is allowed
      if (cleaned.indexOf('-') > 0) {
        cleaned = cleaned.replace(/-/g, '');
      }

      input.value = cleaned;
      this.valueChange.emit(cleaned);
    }

    this.errorStatus.emit(this.showError);
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent): void {
    const key = event.key;

    // Allow digits and minus if it's the first character
    if (!/[\d-]/.test(key)) {
      event.preventDefault();
      this.showError = true;
      this.errorStatus.emit(true);
    }

    const input = this.el.nativeElement;
    if (key === '-' && input.selectionStart !== 0) {
      event.preventDefault(); // Only allow '-' at the beginning
      this.showError = true;
      this.errorStatus.emit(true);
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    let paste = '';
    if (event.clipboardData && typeof event.clipboardData.getData === 'function') {
      paste = event.clipboardData.getData('text');
    }
    if (!/^-?\d+$/.test(paste)) {
      event.preventDefault();
      this.showError = true;
      this.errorStatus.emit(true);
    }
  }
}
